import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useRumViewTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const name = pathname
      .split('/')
      .map(p => p.replace(/\d+/g, '?'))
      .join('/');
    datadogRum.startView({ name });
  }, [pathname]);
};

export default useRumViewTracking;